import { render, staticRenderFns } from "./IconBars.vue?vue&type=template&id=d9b31f9a&functional=true&"
import script from "./IconBars.vue?vue&type=script&lang=js&"
export * from "./IconBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports